export var documentYearlyActivity = function (input) {
    return [
        {
            date: '2024-01-01',
            count: 45
        },
        {
            date: '2024-02-01',
            count: 38
        },
        {
            date: '2024-03-01',
            count: 25
        },
        {
            date: '2024-04-01',
            count: 25
        },
        {
            date: '2024-05-01',
            count: 25
        },
        {
            date: '2024-06-01',
            count: 25
        },
        {
            date: '2024-07-01',
            count: 25
        },
        {
            date: '2024-08-01',
            count: 25
        },
        {
            date: '2024-09-01',
            count: 25
        }
    ];
};
